import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { ICancelledRestoreModel, IUnitSimActiveModel } from '@apps-common/types/management/unit'

export const restoreUnitCancelled = async (model: ICancelledRestoreModel): Promise<IUnitSimActiveModel> =>
  axios.post(`/management/unit/restorecancelled`, model).then((res) => res?.data?.data)

type Props = {
  model: ICancelledRestoreModel
}

export const useManagementRestoreUnitCancelled = (notify?: boolean, onSuccess?: (data: IUnitSimActiveModel) => void) =>
  useMutation({
    mutationKey: ['restoreUnitCancelled'],
    mutationFn: ({ model }: Props) => restoreUnitCancelled(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Restored cancelled device.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to restore cancelled device, please try again.')
      }
    },
    throwOnError: false
  })
